var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 75",
    style: {
      enableBackground: "new 0 0 60 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "016-Array") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,41.5H1c-0.6,0-1,0.4-1,1v24c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1v-24C26,41.9,25.6,41.5,25,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,31.5h20c0.6,0,1-0.4,1-1v-20c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1v20C2,31.1,2.4,31.5,3,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,7.5H35c-0.6,0-1,0.4-1,1v24c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1v-24C60,7.9,59.6,7.5,59,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,41.5H35c-0.6,0-1,0.4-1,1v24c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1v-24C60,41.9,59.6,41.5,59,41.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArray);
export default __webpack_public_path__ + "static/media/array.a5c11cf260106e0713f3f7cf2f11348e.svg";
export { ForwardRef as ReactComponent };